import Vue from "vue"

// axios
import axios from "axios"
import interceptors from "axios"

const axiosInstance = axios.create({
    // You can add your headers here
    // ================================
    // baseURL: 'https://tracetb-api.leavingstone.club/api/',
    baseURL: process.env.VUE_APP_BASE_URL,
    // timeout: 1000,
    // headers: {'X-Custom-Header': 'foobar'}
});

axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token");
axiosInstance.defaults.headers.common["accept-language"] = "ka";
Vue.prototype.$http = axiosInstance;

// Add request/response interceptor
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        // const { config, response: { status } } = error
        const {config, response} = error;
        const originalRequest = config;
        const status = error.response ? error.response.status : null
        let subscribers = [];
        let isAlreadyFetchingAccessToken = false;

        if (status === 401) {
            if (!isAlreadyFetchingAccessToken) {
                isAlreadyFetchingAccessToken = true;

                axiosInstance.post("accounts/refresh_token?RefreshToken=" + localStorage.getItem("refreshToken")).then(res => {
                    const response = res.data
                    isAlreadyFetchingAccessToken = false;
                    localStorage.setItem("token", JSON.stringify(response.tokenResponse.token).replace(/['"]+/g, ""));
                    localStorage.setItem("refreshToken", JSON.stringify(response.tokenResponse.refreshToken).replace(/['"]+/g, ""));
                    subscribers = subscribers.filter(callback => callback())
                });
            }
            const retryOriginalRequest = new Promise(resolve => {
                subscribers.push((accessToken) => {
                    // Make sure to assign accessToken according to your response.
                    // Check: https://pixinvent.ticksy.com/ticket/2413870
                    // Change Authorization header
                    originalRequest.headers.Authorization = "Bearer " + localStorage.getItem("token");
                    resolve(axiosInstance(originalRequest))
                });
            });
            return retryOriginalRequest
        }
        if (status === 401 || status === 406) {window.location.replace("/login");}
        return Promise.reject(error)
    },
);


export default axiosInstance
